import React from 'react';
import styled from 'styled-components'
import DialogTitle from 'containers/CompanyContainer/DialogTitle';
import PropTypes from 'prop-types';

const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 20px 10px 20px;
`
const BodyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    box-sizing: border-box;
`
const ActionsWrapper = styled.div`
    display: flex;
    justify-content: space-around;
`

const CompanyPortalWizardDialog = ({headerProps, body, actions}) => {
    return(
        <MainWrapper>
            <DialogTitle {...headerProps} />
            <BodyWrapper>
                {body}
            </BodyWrapper>
            <ActionsWrapper>
                {actions}
            </ActionsWrapper>
        </MainWrapper>
    )
}

export default CompanyPortalWizardDialog;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyPortalWizardDialog.jsx